import { AppAPI, } from '@moderepo/mode-apis';
/**
 * The types of action that can be dispatched to update this sub state.
 */
export var HomeMembersActionType;
(function (HomeMembersActionType) {
    HomeMembersActionType["SET_HOME_MEMBERS"] = "set home members";
    HomeMembersActionType["SET_HOME_MEMBER"] = "set home member";
    HomeMembersActionType["CLEAR_HOME_MEMBERS"] = "clear home members";
})(HomeMembersActionType || (HomeMembersActionType = {}));
export const setHomeMembers = (homeId, members) => {
    return {
        type: HomeMembersActionType.SET_HOME_MEMBERS,
        homeId,
        members,
    };
};
export const clearHomeMembers = (homeId) => {
    return {
        type: HomeMembersActionType.CLEAR_HOME_MEMBERS,
        homeId,
    };
};
/**
 * Get all members belonged to a home
 * @param homeId - The id of the home
 */
export const fetchHomeMembers = (homeId) => {
    return async (dataDispatch) => {
        const members = await AppAPI.getInstance().getHomeMembers(homeId);
        await dataDispatch(setHomeMembers(homeId, members));
    };
};
/**
 * Add/Invite a member to a home
 * @param homeId - The id of the home we want to add the member
 * @param email | phoneNumber - The email or phone number of the user we want to add.
 */
export const addHomeMember = (homeId, { email, phoneNumber, role }) => {
    return async (dataDispatch) => {
        await AppAPI.getInstance().addHomeMember(homeId, {
            email, phoneNumber, role,
        });
        // New member added so we need to clear the current home members list
        await dataDispatch(clearHomeMembers(homeId));
    };
};
/**
 * Update a home member. Only 'role' can be updated.
 * @param homeId - The id of the home the member belonged to
 * @param memberId - The id of the member we want to change
 * @param role - The role that we want to set
 */
export const updateHomeMember = (homeId, memberId, role) => {
    return async (dataDispatch) => {
        await AppAPI.getInstance().updateHomeMember(homeId, memberId, role);
        // Home member updated so we need to clear the current home members list
        await dataDispatch(clearHomeMembers(homeId));
    };
};
/**
 * Remove a member from a home
 * @param homeId - The id of the home we want to remove the member from
 * @param memberId - The id of the member we want to remove
 */
export const removeHomeMember = (homeId, memberId) => {
    return async (dataDispatch) => {
        await AppAPI.getInstance().removeHomeMember(homeId, memberId);
        // New member removed so we need to clear the current home members list
        await dataDispatch(clearHomeMembers(homeId));
    };
};
